/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase'
import {  Container, Sidebar, Segment, Button, Divider, Feed, Image, Table, Header, Rating, Icon, Loader, Menu, Label  } from 'semantic-ui-react'

import MapGL, { Marker, Popup, SVGOverlay, CanvasOverlay, LinearInterpolator, FlyToInterpolator } from 'react-map-gl';

import { MAPBOX_TOKEN } from '../../../config/tokens'

const SETTINGS = {
      dragPan: true,
      dragRotate: true,
      scrollZoom: true,
      touchZoom: true,
      touchRotate: true,
      keyboard: true,
      doubleClickZoom: true,
      minZoom: 0,
      maxZoom: 20,
      minPitch: 0,
      maxPitch: 85
    };

    function round(x, n) {
      const tenN = Math.pow(10, n);
      return Math.round(x * tenN) / tenN;
    }

    function getRGBA(color) {
      const {r,g,b,a} = color

      const rr = r > 0 ?  Math.floor(255*r) : 0
      const gg = g > 0 ?  Math.floor(255*g) : 0
      const bb = b > 0 ?  Math.floor(255*b) : 0

      if(rr > 255 || gg > 255 || bb > 255)
        return `rgba(${r}, ${g}, ${b}, ${a})`; // this is an error

      return `rgba(${rr}, ${gg}, ${bb}, ${a})`;
    }


class DrawingsMap extends Component {

  // create class wide variable
  theMapGeoQuery;

  state = {


    viewport: {
      bearing: 0,
      // pitch: 50,
      pitch: 0,
      width: 800,
      height: 800,
      latitude: 40,
      longitude: -90,
      zoom: 2,
      center: [40,-90],
    },
    visibleSessions: {},
    loading: true,

    leftSidebarVisible: true,
    activeSessionKey: null,
    sessionsOnMap: {},

  }

  componentDidMount() {
    if(this.state.loading && isLoaded(this.props.sessions))
      this._initializeData()
  }

  componentDidUpdate(prevProps) {
    if(this.state.loading && isLoaded(this.props.sessions))
      this._initializeData()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize);
  }

  // ------------------------------------
  // INITIALIZE EVERYTHING
  // ------------------------------------

  _initializeData = () => {
    console.warn('Initialize Map');

    window.addEventListener('resize', this._resize);
    this._resize();

    // Create a new object collection from sessions
    const { sessions, geoFire } = this.props;

    // CREATE LINES COLLECTION
    let lines = []
    _.forEach(sessions, (session, sessionKey) => {
      _.forEach(session.lines, (line, lineKey) => {

        if(!session.l || typeof session.l[0] !== "number" ) { return }

        const latitude = session.l[0];
        const longitude = session.l[1];

        lines.push({
          ...line,
          username: session.username,
          latitude,
          longitude,
          views: session.views,
          userId: session.userId,
          coordinates: this._getLineCoordinates(line,[latitude, longitude]),
          sessionKey,
          lineKey,
        });
      })
    });
    // console.log('lines',lines)
    // console.log(_.find(sessions));

    // Clean session data, add date, etc
    let filteredSessions = _.pickBy(sessions, s => s.l)
    filteredSessions = _.pickBy(filteredSessions, s => s.username)

    filteredSessions = _.map(filteredSessions, (session, key) => {
      const line = _.find(session.lines,'time') || {time: 100}
      return (
        {
          ...session,
          _key: key,
          createdAt: line.time * 1000,
          latitude: session.l[0],
          longitude: session.l[1],
          coordinates: [session.l[1],session.l[0]],
          otherSessionsByUser: _.filter(sessions,s => s.username === session.username), // bug
        }
      )
    });
    const orderedSessions = _.orderBy(filteredSessions,['createdAt'],['desc'])

    this.setState({
      loading: false,
      sessions: orderedSessions,
      lines,
      activeSession: _.find(sessions),
    });

    // do an initial viewport change
    // this._flyToSession(_.find(sessions))

    // AND KICK OFF GEO FIRE QUERIES

    // this.theMapGeoQuery = geoFire.query({
    //   // center: [10.38, 2.41],
    //   center: [50, -90],
    //   // center: [viewport.latitude, viewport.longitude],
    //   radius: 50
    // });
    //
    // let newVisibleSessions = []
    // let sessionsOnMap = {}
    //
    // this.theMapGeoQuery.on("ready", () => {
    //   // console.log("GeoQuery has loaded and fired all other events for initial data");
    //   this.setState({visibleSessions: newVisibleSessions, sessionsOnMap})
    // });
    //
    // this.theMapGeoQuery.on("key_entered", (key, location, distance) => {
    //   // sessionsOnMap[key] = {location, distance, _key: key}
    //   // newVisibleSessions.push(key)
    // });
    //
    // this.theMapGeoQuery.on("key_exited", function(key, location, distance) {
    //   // delete sessionsOnMap[key]
    //   // _.remove(newVisibleSessions,key)
    // });

  }

  // ------------------------------------
  // RESIZE WINDOW
  // ------------------------------------

  _resize = () => {
    this.setState({ viewport: {...this.state.viewport,width: window.innerWidth,height: window.innerHeight-100 }});
  };

  // ------------------------------------
  // Calculate line coordinates
  // ------------------------------------
    _getLineCoordinates(line, center, sessionKey) {

      if(!center || !line) {
        console.warn('no data');
        return
      }

      let lineCoordinates = []
      let z = 0

      _.forEach(line.line, (dot, i) => {

        const xPoint = Math.floor(line.line[i].x)

        const newLatOffset = 0.000004
        let newLat = center[1] + (newLatOffset * xPoint)

        const yPoint = Math.floor(line.line[i].y)

        const newLongOffset = 0.000008
        const gg = -0.007
        let newLong = center[0] + (newLongOffset * yPoint) + gg

        // also try to create a line
        lineCoordinates.push([newLat,newLong])

      });

      return lineCoordinates
    }

  // ------------------------------------
  // ON VIEWPORT CHANGE
  // ------------------------------------

  _onViewportChange = viewport => {
    this.setState({
    viewport: {...this.state.viewport, ...viewport}
  });


  }

  _flyToSession = ({l}) => {
    this._onViewportChange({
      longitude: l[1],
      latitude: l[0],
      zoom: 10,
      transitionInterpolator: new FlyToInterpolator(),
      transitionDuration: 2000
    });
  };

  // ------------------------------------
  // Zoom FUNCTIONS
  // ------------------------------------
  _zoomIn = () => {
    this._onViewportChange({
      zoom: Math.min((this.state.viewport.zoom + 1),SETTINGS.maxZoom),
      transitionInterpolator: new FlyToInterpolator(),
      transitionDuration: 200
    });
  }
  _zoomOut = () => {
    this._onViewportChange({
      zoom: Math.max((this.state.viewport.zoom - 1),SETTINGS.minZoom),
      transitionInterpolator: new FlyToInterpolator(),
      transitionDuration: 200,
    });
  }

  // ------------------------------------
  // DRAW LINES
  // ------------------------------------

  _renderLine = (points, line) => {
    // console.log('am i xalled?',line)
    let theStrokewidth = 4
    return (
      <g style={ {pointerEvents: 'click', cursor: 'pointer'} }>
        <g
          style={ {pointerEvents: 'visibleStroke'} }
          >
          <path
            style={ {
              fill: 'none',
              // stroke: alphaify(color(index), 0.7),
              stroke: getRGBA(line.color),
              strokeWidth: theStrokewidth,
            } }
            d={ `M${points.join('L')}` }/>
        </g>
      </g>
    );
  }

  _redrawSVGOverlay = ({project}) => {
    const { lines, sessions, viewport } = this.state

    // console.log('svg',viewport)

    if(viewport.zoom > 7)
      return this._renderLines(lines,project)

  }

  _onMarkerClick = (session) => {
    // console.log('clicked')
    this._flyToSession(session)
  }
  _renderSessions = () => {



    const { lines, sessions, viewport, visibleSessions, } = this.state

    if(viewport.zoom > 7)
      return null


    return (

          _.map(sessions, (session, key) => {
            // const session = sessions[sessionKey]

            // if(!session.location || !session.location[0] || !session.location[1])
            if(!session.l || !session.l[0] || !session.l[1])
              return null;

            return (
              <Marker key={`marker-${key}`}
                longitude={session.l[1]}
                latitude={session.l[0]} >
                <Button style={{padding: 2, }} circular onClick={() => this._onMarkerClick(session)} >
                <span aria-label='asdf' role='img'>🙂</span>
                </Button>

              </Marker>
            )
          })

    );
  }
  _renderLines = (lines, project) => {

    console.log('lines',lines)

    return (
      <g>
        {
          _.map(lines, (line, index) => {

            // if(!_.includes(this.state.visibleSessions,line.sessionKey))
            //   return null

            const points = line.coordinates.map(project).map(
              p => [round(p[0], 1), round(p[1], 1)]
            );
            return <g key={ index }>{ this._renderLine(points, line) }</g>;
          })
        }
      </g>
    );
  }



  // ------------------------------------
  // SIDEBAR FUNCTIONS
  // ------------------------------------

  handleButtonClick = () => this.setState({ leftSidebarVisible: !this.state.leftSidebarVisible })

  handleSidebarHide = () => this.setState({ leftSidebarVisible: false })

  handleSessionClick = (e, { name }) => {

    const session = this.props.sessions[name]

    this.setState({ activeSessionKey: name });

    this._flyToSession(session)

  }


  // ------------------------------------
  // RENDER
  // ------------------------------------

  render() {

    const { loading, sessions, activeSessionKey, leftSidebarVisible, visibleSessions } = this.state

    // Dont load map until firebase geoFire data is loaded
    if(loading) { return <Loader active /> }

    // console.log('visibleSessions',visibleSessions)
    return (
      <div>

        <Sidebar.Pushable as={Segment}>

          <Button onClick={this.handleButtonClick} icon='list' />

          <Sidebar
            as={Menu}
            animation='overlay'

            onHide={this.handleSidebarHide}
            vertical
            visible={leftSidebarVisible}

          >

          <Menu.Item header>Recent Drawings</Menu.Item>
          <Menu.Item>
<Feed>
          {
            _.map(sessions, (session, key) => {

              return (
                <Menu.Item
                  key={key}
                  name={session._key}
                  active={activeSessionKey === key}
                  onClick={this.handleSessionClick}
                  >
                {session.views > 0 && <Label color='teal'>{session.views}</Label> }




                <Feed.Event >

      <Feed.Content>

        <Feed.Summary>
          <Feed.User>{session.username}</Feed.User>

        </Feed.Summary>
        <Feed.Meta>
        <Feed.Date>{moment(session.createdAt).fromNow()}</Feed.Date>


        </Feed.Meta>
      </Feed.Content>

    </Feed.Event>
    </Menu.Item>

              )
            })
          }
</Feed>
</Menu.Item>
          </Sidebar>

          <Sidebar.Pusher>


            <MapGL
        {...this.state.viewport}
        onViewportChange={this._onViewportChange}
        mapboxApiAccessToken={MAPBOX_TOKEN}
      >
      <SVGOverlay redraw={ this._redrawSVGOverlay }/>
      { this._renderSessions() }

      <ZoomButtons zoomIn={this._zoomIn} zoomOut={this._zoomOut} />
      </MapGL>


          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );

  }
}

export default compose(
  firebaseConnect([
    // 'geoFire',
    { path: '/geoFire', queryParams: [ 'limitToLast=20' ] }
  ]),
  connect((state) => {
    return ({
      geoFire: state.geoFire,
      sessions: state.firebase.data.geoFire,
    })
  })
)(DrawingsMap)


const ZoomButtons = ({viewport, zoomIn, zoomOut}) => {

    return (
      <div style={{position: 'absolute', bottom: 50, right: 50}}>
    <Button circular icon='zoom in' onClick={zoomIn} />
    <Button circular basic color='black' icon='zoom out' onClick={zoomOut} />
  </div>
    )

}



// WEBPACK FOOTER //
// ./src/components/pages/admin/FeedMap.js